import { Component, OnInit } from '@angular/core';
import { FeatureFlagService } from '../../../../../shared/services/feature-flag.service';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { QuestionComponent } from '../question-component';
import { ShortTextQuestion } from '../../../../job-service/service-models/short-text-question';
import { LengthRule } from '../../../../job-service/service-models/TextQuestion';

@Component({
  selector: 'app-short-text',
  templateUrl: './short-text.component.html',
  styleUrls: ['./short-text.component.scss']
})
export class ShortTextComponent extends QuestionComponent<ShortTextQuestion> implements OnInit {
  downloadRoute: string;
  
  constructor() {
    super();
  }
  
  ngOnInit() {
    this.question = this.question || new ShortTextQuestion();

    if (this.question.answers === undefined) {
      const answer = new Answer();
      answer.questionId = this.question.id;
      answer.questionVersion = this.question.version;
      this.question.answers = [answer];
    }

    this.downloadRoute = `jobs/${this.jobId}/elements/${this.element.id}/questions/${this.question.id}/attachments`;
  }

  getValidationMessaging(): string {
    const validationRule = <LengthRule>this.question.validationRule;
    let message = '';

    if (validationRule.max !== null && validationRule.min !== null) {
      message += `Answer must be an answer between ${validationRule.min} and ${validationRule.max}.`;
    } else if (validationRule.max !== null) {
      message += `Answer must be an answer less than ${validationRule.max}.`;
    } else if (validationRule.min !== null) {
      message += `Answer must be an answer greater than ${validationRule.min}.`;
    }

    return message;
  }
}
